import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class TarefasRecuperacaoCreditoService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/tarefas/recuperacao-credito';
  }

  public criarRecuperacaoCredito(idOperacaoCredito: number, dataRecuperacao: string, valorRecuperacao: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/criar/${idOperacaoCredito}/${dataRecuperacao}/${valorRecuperacao}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public alterarEstadoRecuperacaoCredito(idRecuperacao: number, idEstado: string): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/alterar-estado/${idRecuperacao}/estado/${idEstado}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public removerRecuperacaoCredito(idRecuperacao: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/remover/${idRecuperacao}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public removerTodasAsRecuperacoesCredito(idOperacao: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/remover-todas/${idOperacao}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public processarRecuperacaoCredito(idRecuperacao: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/processar/${idRecuperacao}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public simularRecuperacaoCredito(idOperacaoCredito: number, dataRecuperacao: string): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/simular-recuperacao-credito-concluida/${idOperacaoCredito}/${dataRecuperacao}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

}





